import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ManagerMonthlySalary } from '../types';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  month: number;
  managerId: number;
  year: number;
}

export const getManagerMonthlySalary = async ({
  managerId,
  month,
  year
}: Params): Promise<ManagerMonthlySalary> => {
  const { data } = await api.get<ManagerMonthlySalary>(
    `${BI_BASE_URL}/managers/manager/${managerId}/salary/${month}?year=${year}`
  );

  return data;
};

export const useGetManagerMonthlySalary = (
  managerId: number | null,
  month?: number,
  year?: number
) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MANAGER_MONTHLY_SALARY, managerId, month, year],
    queryFn: () =>
      getManagerMonthlySalary({
        managerId: managerId!,
        month: month!,
        year: year!,
      }),
    enabled: managerId != null && month != null && year != null,
  });
};
